import React, { useState } from "react";
import InputGroup from "canvas-core-react/lib/InputGroup";
import { useTranslation } from "react-i18next";

import CustomCheckbox from "../../shared/custom-components/checkbox";
import CustomInput from "../../shared/custom-components/customInput";
import Modal from "../../utils/customModal";
import SearchUser from "./searchUser";
import useApi from "../../hooks/useApi";
import useForm from "../../hooks/useForm";
import { defaultUserState } from "./util";
import { errorContainer, loadingHtml } from "../../utils/functions";

const AddUser = ({
  onAddUser,
  initialState = defaultUserState,
  readOnly,
  userNumber,
  searchable,
  country,
  institution,
}) => {
  const [userData, setUserData] = useState(initialState);
  const [{ show, content }, setModal] = useState(defaultModal);
  const [searchMode, setSearchMode] = useState(searchable);

  const { handleChange, errors, values, setValue, onSubmit } = useForm({
    initialState: userData,
    callback: onAddUser,
    validation: {
      email: { required: true },
      firstName: { required: true, includeSpecialCharacters: true },
      lastName: { required: true, includeSpecialCharacters: true },
      identification: { required: true },
    },
  });

  const { postApiCAll } = useApi();
  const { t } = useTranslation();

  const onChangePermissions = ({ target: { name, checked } }) => {
    const [nameProp, permission] = name.split("-");
    setValue(nameProp, { ...values[nameProp], [permission]: checked });
  };

  const handleModal = (show = false, content = null) => {
    setModal({ show, content });
  };

  const onSearch = async (value) => {
    handleModal(true, loadingHtml());
    try {
      const {
        data: { data },
      } = await postApiCAll(`/providers/users`, {
        businessId: institution,
        country: country,
        key: value,
      });

      setUserData({
        ...values,
        identification: data.identification,
        lastName: data.lastName,
        firstName: data.firstName,
        email: data.email,
        codUser: value,
        userIsRegistered: true,
      });
      setSearchMode(false);
      handleModal();
    } catch (error) {
      handleModal(
        true,
        getDefaultError(value, () => handleModal())
      );
    }
  };

  return (
    <>
      {searchMode ? (
        <SearchUser
          name={codUser}
          placeholder={t(`${baseName}${codUser}`)}
          onSearch={onSearch}
        />
      ) : (
        <>
          <h4 className="w-100 mb-3">{`${t(
            `${baseName}subtitle`
          )} # ${userNumber}`}</h4>
          <div className="d-flex justify-content-between flex-wrap">
            {values[codUser] && (
              <div className="width-column">
                <CustomInput
                  name={codUser}
                  disabled={readOnly}
                  value={values[codUser]}
                  placeholder={t(`${baseName}${codUser}`)}
                  className="input-new-provider-fix"
                  readOnly
                />
              </div>
            )}

            {options.map((name) => (
              <div className="width-column" key={name}>
                <CustomInput
                  name={name}
                  placeholder={t(`${baseName}${name}`)}
                  disabled={readOnly}
                  value={values[name]}
                  className="input-new-provider-fix"
                  onChange={handleChange}
                  error={errors[name]}
                />
              </div>
            ))}
            <InputGroup
              legend={t(`registerProvider.forms.service.${modRelations}`)}
              className="width-column mt-3 pt-2"
              inline
              id={`${modRelations}-${userNumber}`}
            >
              {permissions.map((name) => {
                const id = `${modRelations}-${name}-${userNumber}`;
                return (
                  <CustomCheckbox
                    key={id}
                    label={t(`types_permissions.${name}`)}
                    disabled={readOnly}
                    checked={values[modRelations][name]}
                    id={id}
                    name={id}
                    onChange={onChangePermissions}
                  />
                );
              })}
            </InputGroup>
          </div>
          <div className="d-flex w-100 flex-column">
            {mods.map((mod) => (
              <InputGroup
                legend={t(`registerProvider.forms.service.${mod}`)}
                inline
                className="width-column pt-3 my-3"
                id={`${modRelations}-${userNumber}`}
                key={mod}
              >
                {permissions.map((name) => {
                  const id = `${mod}-${name}-${userNumber}`;
                  return (
                    <CustomCheckbox
                      key={id}
                      label={t(`types_permissions.${name}`)}
                      disabled={readOnly}
                      id={id}
                      name={id}
                      onChange={onChangePermissions}
                      checked={values[mod][name]}
                    />
                  );
                })}
              </InputGroup>
            ))}
          </div>
          {!readOnly && (
            <div className="w-100 my-5">
              <button className="add-user-last-step" onClick={onSubmit}>
                {t(`${baseName}button`)}
              </button>
            </div>
          )}
        </>
      )}
      <Modal show={show}>{content}</Modal>
    </>
  );
};

export default AddUser;

const options = ["email", "firstName", "lastName", "identification"];
const permissions = ["approval", "capture", "query"];
const mods = ["modUser", "modBills"];
const modRelations = "modRelations";
const codUser = "codUser";
const baseName = "registerProvider.forms.user.";

const defaultModal = { show: false, content: null };

const getDefaultError = (value, action) => {
  return errorContainer(
    "Usuario no encontrado",
    `El usuario con el código ${value} no existe o no se encuentra ligado a esta institución`,
    { continueBtn: { text: "Continuar", action } }
  );
};
